// @generated by protoc-gen-grpc-gateway-es v0.5.0 with parameter "target=ts,generate_name_parser=true"
// @generated from file ai/h2o/cloud/discovery/v1/client_api.proto (package ai.h2o.cloud.discovery.v1, syntax proto3)
/* eslint-disable */

import type { Client } from "./client_pb";
import { RPC } from "../../../../../runtime";

/**
 * @generated from message ai.h2o.cloud.discovery.v1.GetClientRequest
 */
export type GetClientRequest = {
/**
 * Name of the requested Client. For example: "clients/my-client-name".
 *
 * @generated from field: string name = 1;
 */
name?: string;
}
;
/**
 * @generated from message ai.h2o.cloud.discovery.v1.GetClientResponse
 */
export type GetClientResponse = {
/**
 * @generated from field: ai.h2o.cloud.discovery.v1.Client client = 1;
 */
client?: Client;
}
;
/**
 * @generated from message ai.h2o.cloud.discovery.v1.ListClientsRequest
 */
export type ListClientsRequest = {
/**
 * Maximum number of items server should return in the response. When set to 0
 * server will decide how many items to return.
 *
 * @generated from field: int32 page_size = 1;
 */
pageSize?: number;
/**
 * Use value returned in next_page_token to retrieve next page of results.
 *
 * @generated from field: string page_token = 2;
 */
pageToken?: string;
}
;
/**
 * @generated from message ai.h2o.cloud.discovery.v1.ListClientsResponse
 */
export type ListClientsResponse = {
/**
 * @generated from field: repeated ai.h2o.cloud.discovery.v1.Client clients = 1;
 */
clients?: Client[];
/**
 * When not empty server has more results then it returned. Use this value as
 * the page_token in the ListClientsRequest to obtain next page of results.
 *
 * @generated from field: string next_page_token = 2;
 */
nextPageToken?: string;
}
;
/**
 * @generated from rpc ai.h2o.cloud.discovery.v1.ClientService.GetClient
 */
export const ClientService_GetClient = new RPC<GetClientRequest,GetClientResponse>("GET", "/v1/{name=clients/*}");
/**
 * @generated from rpc ai.h2o.cloud.discovery.v1.ClientService.ListClients
 */
export const ClientService_ListClients = new RPC<ListClientsRequest,ListClientsResponse>("GET", "/v1/clients");
